import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/',
    redirect: '/index'
  },
  {
    path: '/',
    component: resolve => require(['@/pages/index/index.vue'], resolve),
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Project',
        component: () => import('@/pages/index/body/body'),
      },
      {
        path: "testcenter",
        name: "testcenter",
        component: () => import("@/pages/index/testcenter/testcenter")
      },
      {
        path: "testbank-detail/:id",
        name: "testbank-detail",
        component: () => import("@/pages/index/testbank-detail/testbank-detail")
      },
      {
        path: "wrong-questions",
        name: "wrong-questions",
        component: () => import("@/pages/index/wrong-questions/wrong-questions")
      },

      {
        path: "examcenter",
        name: "examcenter",
        component: () => import("@/pages/index/examcenter/examcenter")
      },
      {
        path: "exam-detail/:id",
        name: "exam-detail", 
        component: () => import("@/pages/index/exam-detail/exam-detail")
      },
      {
        path: "serveset",
        name: "serveset",
        component: () => import("@/pages/index/serveset/serveset")
      },
      {
        path: "kaoshidaojishi",
        name: "kaoshidaojishi",
        component: () => import("@/pages/index/kaoshidaojishi/kaoshidaojishi")
      },
      {
        path: "hongbang",
        name: "hongbang",
        component: () => import("@/pages/index/hongbang/hongbang")
      },
      {
        path: "videopage",
        name: "videopage",
        component: () => import("@/pages/index/videopage/videoplayer")
      },
      {
        path: "videodetailspage",
        name: "videodetailspage",
        component: () => import("@/pages/index/videoDetailsPage/videodetailspage")
      },
      {
        path: "ocr",
        name: "ocr",
        component: () => import("@/pages/index/ocr/ocr")
      },
      {
        path: "Vip",
        name: "Vip",
        component: () => import("@/pages/index/Vip/Vip")
      },
      {
        path: "qianduanzixue",
        name: "qianduanzixue",
        component: () => import("@/pages/index/qianduanzixue/qianduan")
      },
      {
        path: "qianduan",
        name: "qianduan",
        component: () => import("@/pages/index/qianduan/qianduan")
      },
      {
        path: "houduan",
        name: "houduan",
        component: () => import("@/pages/index/houduan/houduan")
      },
      {
        path: "ceshi",
        name: "ceshi",
        component: () => import("@/pages/index/ceshi/ceshi")
      },
      {
        path: "tool",
        name: "tool",
        component: () => import("@/pages/index/tool/tool")
      },
      {
        path: "javacourse",
        name: "javacourse",
        component: () => import("@/pages/index/JavaCourse/JavaCourse")
      }, {
        path: '/QRcodeGeneration',
        name: 'QRcodeGeneration',
        component: () => import("@/pages/index/tool/QRcodeGeneration")
      }, {
        path: '/Base64Encoding',
        name: 'Base64Encoding',
        component: () => import("@/pages/index/tool/Base64Encoding")
      }, {
        path: '/IP',
        name: 'IP',
        component: () => import("@/pages/index/tool/IP")
      }, {
        path: '/Md5Encryption',
        name: 'Md5Encryption',
        component: () => import("@/pages/index/tool/Md5Encryption")
      }, {
        path: '/SqlCodeFormat',
        name: 'SqlCodeFormat',
        component: () => import("@/pages/index/tool/SqlCodeFormat")
      }, {
        path: '/WordsNumber',
        name: 'WordsNumber',
        component: () => import("@/pages/index/tool/WordsNumber")
      }, {
        path: '/JsonCodeFormat',
        name: 'JsonCodeFormat',
        component: () => import("@/pages/index/tool/JsonCodeFormat")
      }, {
        path: '/NumMoney',
        name: 'NumMoney',
        component: () => import("@/pages/index/tool/NumMoney")
      },
      {
        path: "courseclassification",
        name: "Courseclassification",
        component: () => import("@/pages/index/Courseclassification/Courseclassification.vue")
      },
      {
        path: "userhome",
        name: "userhome",
        redirect: '/userhome/allcourses',
        component: () => import("@/pages/index/userhome/userhome.vue"),
        children: [
          {
            path: "allcourses",
            name: "allcourses",
            component: () => import("@/pages/index/userhome/components/MyCourse.vue"),
          },
          {
            path: "allorders",
            name: "allorders",
            component: () => import("@/pages/index/userhome/components/MyOrder.vue"),
          },
          {
            path: "allfollows",
            name: "allfollows",
            component: () => import("@/pages/index/userhome/components/MyFollow.vue"),
          },
          {
            path: "notebook",
            name: "notebook",
            component: () => import("@/pages/index/userhome/components/MyNotebook.vue"),
          },
        ]
      },
      {
        path: "user",
        name: "user",
        redirect: '/user/setbindsns',
        component: () => import("@/pages/index/userhome/user-detail.vue"),
        children: [
          {
            path: "setbindsns",
            name: "setbindsns",
            component: () => import("@/pages/index/userhome/components/SetBindsns.vue"),
          },
          {
            path: "setprofile",
            name: "setprofile",
            component: () => import("@/pages/index/userhome/components/SetProfile.vue"),
          },
          {
            path: "oplog",
            name: "oplog",
            component: () => import("@/pages/index/userhome/components/Oplog.vue"),
          },
          {
            path: "authenticate",
            name: "authenticate",
            component: () => import("@/pages/index/userhome/components/Authenticate.vue"),
          },
          {
            path: "address",
            name: "address",
            component: () => import("@/pages/index/userhome/components/Address.vue"),
          },
        ]
      },
      {
        path: "vb_category_list",
        name: "vb_category_list",
        component: () => import("@/pages/index/VBscan/vb_category_list")
      },
      {
        path: "vb_assignment",
        name: "vb_assignment",
        component: () => import("@/pages/index/VBscan/vb_assignment")
      },
      {
        path: "server_category_list",
        name: "server_category_list",
        component: () => import("@/pages/index/servescan/server_category_list")
      },
      {
        path: "server_assignment",
        name: "server_assignment",
        component: () => import("@/pages/index/servescan/server_assignment")
      },
      {
        path: "pka_category_list",
        name: "pka_category_list",
        component: () => import("@/pages/index/list/pka_category_list")
      },
      {
        path: "pka_assignment",
        name: "pka_assignment",
        component: () => import("@/pages/index/list/pka_assignment")
      },
      {
        path: "test",
        name: "test",
        component: () => import("@/pages/test/test")
      }
    ]
  },
  {
    path: "/practice",
    name: "practice",
    component: () => import("@/pages/index/practice/practice")
  },
  {
    path: "/teacher-panel",
    name: "teacher-panel",
    component: () => import("@/pages/teacher-panel/teacher-panel")
  },
  {
    path: "/teacher-panel/grading",
    name: "grading",
    component: () => import("@/pages/teacher-panel/grading/grading")
  },
  {
  path: '/vm/',
  component: resolve => require(['@/pages/index/servescan/vmindex.vue'], resolve),
  redirect: '/testdetail',
  children: [
    {
      path: "testdetail",
      name: "testdetail",
      component: () => import("@/pages/index/servescan/testdetail")
    },]
  },
  {
  path: '/vb/',
  component: resolve => require(['@/pages/index/VBscan/vbindex.vue'], resolve),
  redirect: '/testdetail',
  children: [
    {
      path: "testdetail",
      name: "testdetail",
      component: () => import("@/pages/index/VBscan/testdetail")
    },]
  },

  {
    path: '/index',
    name: 'index',
    component: resolve => require(['@/pages/index/index.vue'], resolve),
  },
  ],
  linkActiveClass: 'active', 
   scrollBehavior () {
    return { x: 0, y: 0 }
  }

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js